import { ApproveLimitV2ReduxState, CreateDraftLimitV2ReduxState, DeleteLimitV2ByExternalIdReduxState, DeleteLimitV2ReduxState, FreezeLimitV2ReduxState, LatestVersionLimitsV2ReduxState, LimitConfigV2ReduxTypes, ListApprovedLimitsV2ReduxState, PublishLimitV2ReduxState, RejectLimitV2ReduxState, SentBackLimitV2ReduxState, UnfreezeLimitV2ReduxState, UpdateDraftLimitV2ReduxState, LimitConfigListUiState } from './types';

const LIMIT_CONFIG_LIST_UI_INIT_STATE: LimitConfigListUiState = {
  currentPage: 1,
  searchFilter: {},
  sort: { field: "updatedOn", order: false },
  isFilterApplied: false
};

/** List UI state — intentionally ignores entity RESET so filters survive route changes */
const LimitConfigListUiReducer = (
  state: LimitConfigListUiState = LIMIT_CONFIG_LIST_UI_INIT_STATE,
  action: { type: string; payload?: Partial<LimitConfigListUiState> }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.SET_LIMIT_CONFIG_LIST_UI:
      return {
        ...state,
        ...action.payload
      };
    case LimitConfigV2ReduxTypes.RESET_LIMIT_CONFIG_LIST_UI:
      return { ...LIMIT_CONFIG_LIST_UI_INIT_STATE };
    default:
      return state;
  }
};

const INIT_STATE: ListApprovedLimitsV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

export { LimitConfigListUiReducer };


const ListApprovedLimitsV2Reducer = (
  state: ListApprovedLimitsV2ReduxState = INIT_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.FETCH_LIST_APPROVED_LIMITS_V2:
      return { ...state, loading: true, data: null, error: null };

    case LimitConfigV2ReduxTypes.FETCH_LIST_APPROVED_LIMITS_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };

    case LimitConfigV2ReduxTypes.FETCH_LIST_APPROVED_LIMITS_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };

    case LimitConfigV2ReduxTypes.RESET_LIST_APPROVED_LIMITS_V2:
      return { ...INIT_STATE };

    default:
      return { ...state };
  }
};

export { ListApprovedLimitsV2Reducer };

const INIT_LATEST_VERSION_STATE: LatestVersionLimitsV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const LatestVersionLimitsV2Reducer = (
  state: LatestVersionLimitsV2ReduxState = INIT_LATEST_VERSION_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.FETCH_LATEST_VERSION_LIMITS_V2:
      return { ...state, loading: true, data: null, error: null };

    case LimitConfigV2ReduxTypes.FETCH_LATEST_VERSION_LIMITS_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };

    case LimitConfigV2ReduxTypes.FETCH_LATEST_VERSION_LIMITS_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };

    case LimitConfigV2ReduxTypes.RESET_LATEST_VERSION_LIMITS_V2:
      return { ...INIT_LATEST_VERSION_STATE };

    default:
      return { ...state };
  }
};

export { LatestVersionLimitsV2Reducer };

const INIT_CREATE_DRAFT_LIMIT_STATE: CreateDraftLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const CreateDraftLimitV2Reducer = (
  state: CreateDraftLimitV2ReduxState = INIT_CREATE_DRAFT_LIMIT_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.CREATE_DRAFT_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };

    case LimitConfigV2ReduxTypes.CREATE_DRAFT_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };

    case LimitConfigV2ReduxTypes.CREATE_DRAFT_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };

    case LimitConfigV2ReduxTypes.RESET_CREATE_DRAFT_LIMIT_V2:
      return { ...INIT_CREATE_DRAFT_LIMIT_STATE };

    default:
      return { ...state };
  }
};

export { CreateDraftLimitV2Reducer };

const INIT_PUBLISH_LIMIT_STATE: PublishLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const PublishLimitV2Reducer = (
  state: PublishLimitV2ReduxState = INIT_PUBLISH_LIMIT_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.PUBLISH_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };

    case LimitConfigV2ReduxTypes.PUBLISH_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };

    case LimitConfigV2ReduxTypes.PUBLISH_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };

    case LimitConfigV2ReduxTypes.RESET_PUBLISH_LIMIT_V2:
      return { ...INIT_PUBLISH_LIMIT_STATE };

    default:
      return { ...state };
  }
};

export { PublishLimitV2Reducer };

const INIT_UPDATE_DRAFT_LIMIT_STATE: UpdateDraftLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const UpdateDraftLimitV2Reducer = (
  state: UpdateDraftLimitV2ReduxState = INIT_UPDATE_DRAFT_LIMIT_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.UPDATE_DRAFT_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };

    case LimitConfigV2ReduxTypes.UPDATE_DRAFT_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };

    case LimitConfigV2ReduxTypes.UPDATE_DRAFT_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };

    case LimitConfigV2ReduxTypes.RESET_UPDATE_DRAFT_LIMIT_V2:
      return { ...INIT_UPDATE_DRAFT_LIMIT_STATE };

    default:
      return { ...state };
  }
};

export { UpdateDraftLimitV2Reducer };

const INIT_APPROVE_LIMIT_STATE: ApproveLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const ApproveLimitV2Reducer = (
  state: ApproveLimitV2ReduxState = INIT_APPROVE_LIMIT_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.APPROVE_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };
    case LimitConfigV2ReduxTypes.APPROVE_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case LimitConfigV2ReduxTypes.APPROVE_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    case LimitConfigV2ReduxTypes.RESET_APPROVE_LIMIT_V2:
      return { ...INIT_APPROVE_LIMIT_STATE };
    default:
      return { ...state };
  }
};

export { ApproveLimitV2Reducer };

const INIT_REJECT_LIMIT_STATE: RejectLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const RejectLimitV2Reducer = (
  state: RejectLimitV2ReduxState = INIT_REJECT_LIMIT_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.REJECT_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };
    case LimitConfigV2ReduxTypes.REJECT_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case LimitConfigV2ReduxTypes.REJECT_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    case LimitConfigV2ReduxTypes.RESET_REJECT_LIMIT_V2:
      return { ...INIT_REJECT_LIMIT_STATE };
    default:
      return { ...state };
  }
};

export { RejectLimitV2Reducer };

const INIT_SENT_BACK_LIMIT_STATE: SentBackLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const SentBackLimitV2Reducer = (
  state: SentBackLimitV2ReduxState = INIT_SENT_BACK_LIMIT_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.SENT_BACK_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };
    case LimitConfigV2ReduxTypes.SENT_BACK_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case LimitConfigV2ReduxTypes.SENT_BACK_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    case LimitConfigV2ReduxTypes.RESET_SENT_BACK_LIMIT_V2:
      return { ...INIT_SENT_BACK_LIMIT_STATE };
    default:
      return { ...state };
  }
};

export { SentBackLimitV2Reducer };

const INIT_DELETE_LIMIT_STATE: DeleteLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const DeleteLimitV2Reducer = (
  state: DeleteLimitV2ReduxState = INIT_DELETE_LIMIT_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.DELETE_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };
    case LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    case LimitConfigV2ReduxTypes.RESET_DELETE_LIMIT_V2:
      return { ...INIT_DELETE_LIMIT_STATE };
    default:
      return { ...state };
  }
};

export { DeleteLimitV2Reducer };

const INIT_DELETE_LIMIT_BY_EXTERNAL_ID_STATE: DeleteLimitV2ByExternalIdReduxState = {
  loading: false,
  data: null,
  error: null,
};

const DeleteLimitV2ByExternalIdReducer = (
  state: DeleteLimitV2ByExternalIdReduxState = INIT_DELETE_LIMIT_BY_EXTERNAL_ID_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_BY_EXTERNAL_ID:
      return { ...state, loading: true, data: null, error: null };
    case LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_BY_EXTERNAL_ID_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case LimitConfigV2ReduxTypes.DELETE_LIMIT_V2_BY_EXTERNAL_ID_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    case LimitConfigV2ReduxTypes.RESET_DELETE_LIMIT_V2_BY_EXTERNAL_ID:
      return { ...INIT_DELETE_LIMIT_BY_EXTERNAL_ID_STATE };
    default:
      return { ...state };
  }
};

export { DeleteLimitV2ByExternalIdReducer };

const INIT_FREEZE_LIMIT_V2_STATE: FreezeLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const FreezeLimitV2Reducer = (
  state: FreezeLimitV2ReduxState = INIT_FREEZE_LIMIT_V2_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.FREEZE_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };
    case LimitConfigV2ReduxTypes.FREEZE_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case LimitConfigV2ReduxTypes.FREEZE_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    case LimitConfigV2ReduxTypes.RESET_FREEZE_LIMIT_V2:
      return { ...INIT_FREEZE_LIMIT_V2_STATE };
    default:
      return { ...state };
  }
};

export { FreezeLimitV2Reducer };

const INIT_UNFREEZE_LIMIT_V2_STATE: UnfreezeLimitV2ReduxState = {
  loading: false,
  data: null,
  error: null,
};

const UnfreezeLimitV2Reducer = (
  state: UnfreezeLimitV2ReduxState = INIT_UNFREEZE_LIMIT_V2_STATE,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case LimitConfigV2ReduxTypes.UNFREEZE_LIMIT_V2:
      return { ...state, loading: true, data: null, error: null };
    case LimitConfigV2ReduxTypes.UNFREEZE_LIMIT_V2_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case LimitConfigV2ReduxTypes.UNFREEZE_LIMIT_V2_ERROR:
      return { ...state, loading: false, error: action.payload.error };
    case LimitConfigV2ReduxTypes.RESET_UNFREEZE_LIMIT_V2:
      return { ...INIT_UNFREEZE_LIMIT_V2_STATE };
    default:
      return { ...state };
  }
};

export { UnfreezeLimitV2Reducer };
